import { render } from "./departManage.vue?vue&type=template&id=434ac85d"
import script from "./departManage.vue?vue&type=script&lang=js"
export * from "./departManage.vue?vue&type=script&lang=js"

import "./departManage.vue?vue&type=style&index=0&id=434ac85d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__